/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

function isIE() {

    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");

    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))      // If Internet Explorer, return version number
        return true;
    else                 // If another browser, return 0
        return false;

    return false;
}

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired


          $(window).on("load", function () {
              $(".js-banner").addClass("is-shown")
                  .delay(500)
                  .queue(function (e) {
                      $("#js-header").addClass("is-shown")
                          .delay(1e3)
                          .queue(function (e) {
                              $("#js-headers").addClass("is-shown")
                                  .delay(500)
                                  .queue(function (e) {
                                      $("#js-hero-people").addClass("is-shown")
                                          .delay(700)
                                          .queue(function (e) {
                                              $("#js-hero-tagline").addClass("is-shown")
                                                  .delay(700)
                                                  .queue(function (e) {
                                                      $("#js-hero-cta").addClass("is-shown"), r.addClass("is-shown");
                                                  });
                                          });
                                  });
                          });
                  });
          });

          if(isIE() || navigator.userAgent.match(/Windows Phone/i) || (/Edge\/12./i.test(navigator.userAgent)) || (/Edge\/13./i.test(navigator.userAgent)) || (/Edge\/14./i.test(navigator.userAgent))){

              jQuery('body').addClass('IEbrowser');

          };

          $(document).ready(function(){
              $("#hamburger-menu").click(function(){
                  $("body").toggleClass('mobile-nav-open');
                  $("#hamburger-menu").toggleClass('active');
              });
          });

          $(function() {
              var header = $(".header-top, .hamburger-menu");
              $(window).scroll(function() {
                  var scroll = $(window).scrollTop();

                  if (scroll >= 1) {
                      header.addClass("header-alt");
                  } else {
                      header.removeClass("header-alt");
                  }
              });
          });

      }
    },
    // Home page
    'home': {
      init: function() {
          // Select all links with hashes
          $('a.scroll-down[href*="#"]')
          // Remove links that don't actually link to anything
              .not('[href="#"]')
              .not('[href="#0"]')
              .click(function(event) {
                  // On-page links
                  if (
                      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
                      &&
                      location.hostname == this.hostname
                  ) {
                      // Figure out element to scroll to
                      var target = $(this.hash);
                      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                      // Does a scroll target exist?
                      if (target.length) {
                          // Only prevent default if animation is actually gonna happen
                          event.preventDefault();
                          $('html, body').animate({
                              scrollTop: target.offset().top
                          }, 1000, function() {
                              // Callback after animation
                              // Must change focus!
                              var $target = $(target);
                              $target.focus();
                              if ($target.is(":focus")) { // Checking if the target was focused
                                  return false;
                              } else {
                                  $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
                                  $target.focus(); // Set focus again
                              };
                          });
                      }
                  }
              });

          $('.home-slider').owlCarousel({
              loop:true,
              nav:false,
              items:1
          })

          if($('.services_slider').length)
          {
              var servicesSlider = $('.services_slider');

              servicesSlider.owlCarousel(
                  {
                      loop: true,
                      center: true,
                      margin: 67,
                      stagePadding: 153,
                      mouseDrag: true,
                      dots: true,
                      dotsSpeed: 600,
                      responsive:
                          {
                              0:
                                  {
                                      items:1,
                                      margin: 15,
                                      center: false,
                                      stagePadding: 15,
                                      dots: false
                                  },
                              575:
                                  {
                                      items:3,
                                      center: true,
                                      stagePadding: 350
                                  },
                              1440:
                                  {
                                      items:4,
                                      margin: 67,
                                      stagePadding: 153,
                                      dots: true,
                                  }
                          }
                  });

              // Handle Left Nav Arrow
              if($('.services_slider_nav_left').length)
              {
                  $('.services_slider_nav_left').on('click', function()
                  {
                      servicesSlider.trigger('prev.owl.carousel');
                  });
              }

              // Handle Right Nav Arrow
              if($('.services_slider_nav_right').length)
              {
                  $('.services_slider_nav_right').on('click', function()
                  {
                      servicesSlider.trigger('next.owl.carousel');
                  });
              }
          }
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page

          $('.testimonial-slider').owlCarousel({
              loop: true,
              items:1,
              mouseDrag: true,
              dots: true,
              dotsSpeed: 600
          });
      }
    },

      'single_services': {
          init: function() {
              // JavaScript to be fired on the about us page

              $('.single-services-slider').owlCarousel({
                  loop:true,
                  nav:false,
                  items:1,
                  autoplay:true,
                  animateOut: 'fadeOut',
                  animateIn: 'fadeIn',
                  autoplayTimeout:10000
              });
          }
      }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.